
import {Application, AppState} from "../application/application";
import webAPI from "../api/web-api-2";

export class BalanceWatcher
{
	private TAG = "BalanceWatcher";

	private current = null;
	private warnedAlready = false;
	private enabled : boolean;

	constructor(private app : Application)
	{

	}

	minToCredit(min : number) : number
	{
		let roomPrice : number = null;

		try
		{
			switch (this.app.getState())
			{
				case AppState.privateShow:
					roomPrice = this.app.chatServer.currentRoom.getPrivatePrice();
					break;
				case AppState.exclusiveShow:
					roomPrice = this.app.chatServer.currentRoom.getExclusivePrice();
					break;
				case AppState.voyeurShow:
					roomPrice = this.app.chatServer.currentRoom.getVoyeurPrice();
					break;
				case AppState.groupShow:
					roomPrice = this.app.chatServer.currentRoom.getGroupPrice();
					break;
			}
		}
		catch (ignored)
		{
			roomPrice = null;
		}

		return roomPrice ? min * roomPrice : null
	}

	setCredits(credits : number)
	{
		console.log(this.TAG, "Balance changed", this.current, "->", credits);
		console.log(this.TAG, "Enabled", this.enabled);

		const oldCredits = this.current;
		this.current = credits;


		const warnLimit = this.minToCredit(3);

		console.log(this.TAG, "Warn limit", warnLimit);

		if (this.enabled && oldCredits !== null)
		{
			if (warnLimit && oldCredits > credits)
			{
				console.log(this.TAG, "Loosing credits...");
				console.log(this.TAG, "WarnedAlredy", this.warnedAlready);
				// Loosing credits
				if (!this.warnedAlready && credits < warnLimit)
				{
					console.log(this.TAG, "Needs warning");
					this.warn(credits);
					this.warnedAlready = true;
				}
			}
			else if (oldCredits < credits)
			{
				console.log(this.TAG, "Gaining credits");
				console.log(this.TAG, "WarnedAlredy", this.warnedAlready);
				// Gaining credits
				if (this.warnedAlready && credits > warnLimit) {
					console.log(this.TAG, "Over the limit, needs to hide warning");

					this.warnedAlready = false;
					this.hideWarn();
				}
			}
		}


	}

	warn(credits : number = null)
	{
		if (credits === null) credits = this.current;

		this.hideWarn();

		const title = this.app.translator.t("balance_watcher_title")
			.replace("{{name}}", this.app.options.auth.userName);

		const $topupLink = $("<a href='#' class='sxc-link' />")
			.text("Töltés most!")
			.click((e) => {
				e.preventDefault();
				this.app.showTopup(true);
			});

		const $cb = $("<a class='sxccsn-bp-cb' href='#' />")
			.text(this.app.translator.t("balance_watcher_balance_protection"))
			.click((e) => {
				e.preventDefault();
				this.activateBP($cb);
			});

		const $notif = $("<div />")
			.append(
				$("<div class='sxccsn-title' />").text(title),
				$("<p />")
					.append(this.app.translator.t("balance_watcher_desc1"))
					.append( " ")
					.append( $topupLink),
				$("<p />")
					.html(this.app.translator.t("balance_watcher_desc2"))
					.append("<br/>")
					.append($cb)
			);


		this.app.view.streamNotificationManager.add(
			$notif,
			"big",
			"low-balance",
			3 * 60 * 1000,
			() => null);
	}

	activateBP($cb)
	{
		if (this.app.topup.isQuickBuyEnabled())
		{
			$cb.addClass("checked");

			const instantQB = this.current < 500;

			if (instantQB)
			{
				// Instant topup
				this.app.topup.getSecurionPayHandler().doQuickBuy(
					1000,
					{},
					(success, data) =>
					{
						if (success) {
							this.app.view.toastManager.push(
								data,
								{timeout: 7000, instant: true});
						} else {
							this.app.view.toastManager.push(
								data,
								{timeout: 7000, instant: true, strong: true});
						}
					}
				);
			}

			webAPI.post("credit/enableAutoPay", {})
				.then(() => {
					if (!instantQB) {
						this.app.view.toastManager.push(
							this.app.translator.t("balance_watcher_bp_activated"),
							{timeout: 7000, instant: true});
					}
				}).catch(() => {
					this.app.view.toastManager.push(
						this.app.translator.t("balance_watcher_bp_activate_failed"),
						{timeout: 7000, instant: true});
				});

			setTimeout(() => {
				this.hideWarn();
			}, 500);
		}
		else
		{
			this.hideWarn();
			this.app.showTopup(true, "creditcard-e", 1000);
		}

	}

	hideWarn()
	{
		this.app.view.streamNotificationManager.clearByTag("low-balance")
	}

	setEnabled(enabled : boolean = true)
	{
		this.enabled = enabled;
	}
}
